// ── 홍보물 관리 — 상수 및 유틸리티 ─────────────────────────────────────────────
import React from 'react';
import { todayKST } from '../../../utils/date';

// promotional_orders / promotional_order_items 컬럼 매핑
export const PROMO_HEADERS = [
  { label: '접수일자',    db: 'promotional_orders.received_date' },
  { label: '카테고리',    db: 'promotional_orders.category_id → product_categories.name' },
  { label: '접수한 사람', db: 'promotional_orders.sales_person_name' },
  { label: '상호',        db: 'promotional_orders.company_name' },
  { label: '받는분 주소', db: 'promotional_orders.address' },
  { label: '홍보물',      db: 'promotional_order_items.item_name' },
  { label: '발주',        db: null },   // 일반 아이템 업무 단계 체크박스
  { label: '택배정보',    db: 'promotional_order_items.courier, tracking_number' },
  { label: '',            db: null },   // 액션 열
];

export const MOBILE_BREAKPOINT = 768;

// KST 오늘 날짜 YYYY-MM-DD
export const getKstToday = todayKST;

// 금액 천단위 포맷
export function fmtPrice(n) {
  return Number(n || 0).toLocaleString() + '원';
}

// 빈 주문 폼 초기값 반환
export function emptyOrderForm() {
  return {
    received_date:     getKstToday(),
    category_id:       '',   // product_categories.id (필수)
    sales_person_name: '',
    company_name:      '',
    address:           '',
    phone:             '',
    mobile_phone:      '',
    memo:              '',
    // courier/tracking_number는 아이템 단위로 관리 (공장별로 택배사가 다름)
    items: [],           // [{ item_id, item_name, quantity, unit_price, courier, tracking_number }]
  };
}

// 폼 필드 레이아웃 헬퍼 (라벨 + 인풋 세트) — OrderModal에서 사용
export function Field({ label, children }) {
  return (
    <div style={{ display: 'grid', gap: 4 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-muted)' }}>{label}</div>
      {children}
    </div>
  );
}
